import { Authentication } from '@leedpulse-monorepo/classes';
import Failure from '../../../core/Failure';
import HttpClient from '../../../core/HttpClient';

interface GetSubscriptionOwnersContactsPayload {
  company_id: string;
  subscription_id: string;
}

export interface SubscriptionOwnerContacts {
  uid: string;
  firstname: string;
  lastname: string;
  /** Contacts this user owns on the number */
  contacts_count: number;
}

/**
 * Users currently holding a number, with the count of their contacts on it. Read before the
 * number goes to another user, to ask whether these contacts follow.
 */
export async function getSubscriptionOwnersContacts(
  payload: GetSubscriptionOwnersContactsPayload,
  auth: Authentication,
): Promise<SubscriptionOwnerContacts[]> {
  try {
    const response = await HttpClient.post(
      '/company/subscription/owners-contacts',
      { company_id: payload.company_id, subscription_id: payload.subscription_id },
      auth.token,
    );

    return (response.data?.owners ?? []) as SubscriptionOwnerContacts[];
  } catch (e) {
    console.error('getSubscriptionOwnersContacts error:', e);
    if (e instanceof TypeError && e.message === 'Failed to fetch') {
      throw new GetSubscriptionOwnersContactsFailure('Le serveur ne répond pas');
    } else if (e instanceof Error) {
      throw new GetSubscriptionOwnersContactsFailure(e.message);
    }
    return Promise.reject(e);
  }
}

export class GetSubscriptionOwnersContactsFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}